/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {TertiaryIconButton} from '@ion/dls/src/components/buttons/TertiaryIconButton';
import {FormItem} from '@ion/dls/src/components/forms/FormItem';
import {DeleteIcon} from '@ion/dls/src/icons/DeleteIcon';

export interface DeleteServiceEntryProps {
  onDelete?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, id?: number) => void;
}

export interface DeleteServiceEntryButtonProps extends DeleteServiceEntryProps {
  id?: number;
  level?: number;
}

const useStyles = makeStyles(() => ({
  deleteStyle : {
    top : '25px'
  },
  deleteIconContainer : {
    display        : 'flex',
    justifyContent : 'flex-end'
  }
}));

/**
 * Displays the delete icon for a service entry.
 *
 * ```typescript
 *
 *  import ServiceEntry from './ServiceEntry';
 *
 *  <DeleteServiceEntryButton level={level} id={id} onDelete={onDelete} />
 *
 * ```
 */
export const DeleteServiceEntryButton = ({
  id,
  level,
  onDelete
}: DeleteServiceEntryButtonProps) => {
  const classes = useStyles();
  return (
    <FormItem disableMinWidth customWidth={1}>
      <div className={classes.deleteIconContainer}>
        { level > 1 ? (
          <TertiaryIconButton icon={<DeleteIcon />}
            className={classes.deleteStyle}
            key={`deleteButton_${id}`}
            id={id}
            onClick={onDelete} />
        ) : <div/>
        }
      </div>
    </FormItem>
  );
};

export default DeleteServiceEntryButton;
